module.exports = __webpack_public_path__ + "img/trash.724c9e41.svg";